import gpuHostingImg from "public/iaas/gpu_hosting.png";
import { SimpleList } from "@/components/list";

const NAD_POINTS = [
  "Custom blueprints tailored for business-specific needs.",
  "High availability frameworks with built-in redundancy.",
  "Scalable design to support growth and cloud integration.",
];

const ID_POINTS = [
  "End-to-end rollout of wired, wireless, and hybrid networks.",
  "Cloud-based networking for agility and remote management.",
  "SDN & SD-WAN integration for optimized traffic control.",
];

const SECURITY_POINTS = [
  "Zero-trust security frameworks to prevent unauthorized access.",
  "Industry compliance with GDPR, ISO 27001, and security standards.",
  "AI-driven threat detection for proactive cybersecurity.",
];

const PERFORMANCE_POINTS = [
  "Traffic engineering & AI-powered analytics for reduced latency.",
  "Load balancing & bandwidth management for seamless connectivity.",
  "Cloud adoption & data center migrations with minimal downtime.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of Network Design & Deployment",
  list: [
    {
      content: <SimpleList points={NAD_POINTS} />,
      image: gpuHostingImg,
      title: "Network Architecture Design",
    },
    {
      content: <SimpleList points={ID_POINTS} />,
      image: gpuHostingImg,
      title: "Infrastructure Deployment",
    },
    {
      content: <SimpleList points={SECURITY_POINTS} />,
      image: gpuHostingImg,
      title: "Security & Compliance Implementation",
    },
    {
      content: <SimpleList points={PERFORMANCE_POINTS} />,
      image: gpuHostingImg,
      title: "Performance Optimization & Migration",
    },
  ],
};
